import type React from 'react'

import { TextBoxMaxLine1FontXl } from 'atoms/TextBox/Templates'
import { VideoPreviewsBodySC, VideoPreviewsSC } from './VideoPreviews.styled'

export interface IVideoPreviews {
  title: string
  description: string
  children: React.ReactNode
}

export const VideoPreviews = ({ title, children }: IVideoPreviews) => {
  return (
    <VideoPreviewsSC>
      <TextBoxMaxLine1FontXl title={title} />

      <VideoPreviewsBodySC>{children}</VideoPreviewsBodySC>
    </VideoPreviewsSC>
  )
}
